import type { NamespaceSchema } from './types';

// Field paths match apps/api/src/core/email/settings.ts (interface
// EmailSettings). SMTP host / port / username / password / Mailgun keys
// are env-only and intentionally not in this schema.
//
// A richer custom EmailSettingsEditor with per-locale header/footer
// editors + test-send buttons lives in routes/Configs.tsx — this schema
// is the structured fallback.

export const emailSettings: NamespaceSchema = {
  namespace: 'email-settings',
  label: 'Email',
  description: 'Outbound transactional email. Real SMTP / Mailgun credentials live in env. These fields control From identity + admin routing only.',
  sections: [
    {
      label: 'From identity',
      fields: [
        { kind: 'text', key: 'fromName', label: 'From name', placeholder: 'DriveCars', description: 'Overrides SMTP_FROM_NAME on the From: header.' },
        { kind: 'email', key: 'fromAddress', label: 'From address', placeholder: 'no-reply@drivecars.ai' },
        { kind: 'email', key: 'adminEmail', label: 'Admin notification email', placeholder: 'master@drivecars.ai', description: 'Receives booking-confirmation-admin etc. When empty, every user with role=admin is fanned out to.' },
      ],
    },
  ],
};
